module.exports = __webpack_public_path__ + "media/我能购买人才公寓吗.b2cf4af5.mp4";